import {useFeatureFlag} from '@github-ui/react-core/use-feature-flag'

import {ViewTypeParam} from '../../api/view/contracts'
import {useViews} from '../../hooks/use-views'

type UseTableCopilotTasks = {
  /** Whether or not the table should show copilot tasks nested under parent items */
  copilotTasksEnabled: boolean
  /** Whether to show multiple agent task sub-rows per item (vs a single sub-row). */
  multipleSubrowsEnabled: boolean
}

export const useTableCopilotTasks = (): UseTableCopilotTasks => {
  /* eslint-disable-next-line @github-ui/github-monorepo/no-use-feature-flags --
     TODO: Migrate to isFeatureEnabled from @github-ui/feature-flags. See
     https://thehub.github.com/epd/engineering/dev-practicals/frontend/react/data-router/migration/app-payload-deprecation/ */
  const projectsCopilotTasksStatus = useFeatureFlag('projects_copilot_tasks_status')
  /* eslint-disable-next-line @github-ui/github-monorepo/no-use-feature-flags --
     TODO: Migrate to isFeatureEnabled from @github-ui/feature-flags. */
  const multipleSubrows = useFeatureFlag('memex_multiple_subrows')
  const {currentView} = useViews()

  const isTable = currentView?.localViewState?.layout === ViewTypeParam.Table
  const agentAssignmentVisible = currentView?.localViewState?.layoutSettings?.table?.agentAssignment?.visible ?? true

  const enabled = projectsCopilotTasksStatus && isTable && agentAssignmentVisible

  return {
    copilotTasksEnabled: enabled,
    multipleSubrowsEnabled: enabled && multipleSubrows,
  }
}
